import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import editor from "../../Assets/carlover.png";
import img2 from "../../Assets/drlap.png";
import suicide from "../../Assets/flowere-commerc.png";
import macbook from "../../Assets/mac-os.png";
import lastProj from "../../Assets/carSite.png";
import talabatey from "../../Assets/image.png";
import carRental from "../../Assets/carRental.png";
import gsapProject from "../../Assets/gsapProject.png";
import Apple3d from "../../Assets/Apple3d.png"
import portfolio3D from "../../Assets/3dapp.png"
import subrbia3D from "../../Assets/3d-skateboard.png"
import storeIt from "../../Assets/storeIt.png"
import puretik from "../../Assets/puretik.png"


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={img2}
              isBlog={false}
              title="DR.Lab"
              description="A desktop application built using React.js and Electron for the Puertik team. The project helped me learn new API structures and how to handle a front-end application with SQLite database integration. You can download the app from the website when click on button demo."
              demoLink="https://www.drlab.app/"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={storeIt}
              isBlog={false}
              title="Storage Platform"
              description="StorIt is a sophisticated, cloud-based file storage and sharing platform inspired by Google Drive. It enables users to upload, organize, manage, and share files securely with built-in authentication, real-time storage analytics, and intelligent file organization."
              ghLink="https://github.com/TabarakCodeCraft/StoreIt-Clone-Google-Drive"
              demoLink="https://store-it-clone-google-drive-4ge8.vercel.app/"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={puretik}
              isBlog={false}
              title="PureTik website"
              description="PureTik is a technology-driven company specializing in delivering comprehensive digital solutions that empower businesses to grow and succeed. The company offers a wide range of services including web and mobile development, cloud solutions, cybersecurity, and data analytics, all tailored to meet unique business needs."
              ghLink="https://www.puretik.com/ar"
              demoLink="https://www.puretik.com/ar"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={talabatey}
              isBlog={false}
              title="Talabatey Packaging System"
              description="Web application (Dashboard) built using React.js and RESTful APIs for the Talabatey company. Delivered a redesigned frontend for Talabaty Packaging System used by over 5,000 monthly users, focusing on responsive and engaging UI/UX."
              demoLink="https://www.linkedin.com/posts/tabarak-ali-star_im-so-happy-about-my-latest-achievement-activity-7357476830506827777-OMS0?utm_source=share&utm_medium=member_desktop&rcm=ACoAAErlMzwB9H1ANRGpX4abAEm-Ya0o8BQxLGc"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={subrbia3D}
              isBlog={false}
              title="Skateboard App"
              description="An interactive 3D skateboard customization web application built with Next.js, Typescript, React Three Fiber, and modern web technologies like GSAP lib. Customize your skateboard with real-time 3D visualization, physics simulation, and smooth animations."
              ghLink="https://github.com/TabarakCodeCraft/3d-Skateboard.git"
              demoLink="https://3d-skateboard-two.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Apple3d}
              isBlog={false}
              title="Macbook Style"
              description="Apple-style 3D website built with React, Three.js, GSAP, and TailwindCSS! Showcase products in immersive 3D scenes, scroll-animated models, and pinned sections. Featuring responsive design, smooth timeline animations, and visually striking image transitions—perfect for developers creating interactive, modern web experiences."
              ghLink="https://github.com/TabarakCodeCraft/Apple-Website.git"
              demoLink="https://macbook-3d-by-tabarak.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portfolio3D}
              isBlog={false}
              title="Awwwards Portfolio"
              description="This is a fully animated, interactive, 3D developer portfolio designed to impress clients, recruiters, and hiring managers. It's more than a portfolio—it's a web experience built with production-level code, scroll-based animations, and real-world best practices."
              ghLink="https://github.com/TabarakCodeCraft/My-New-Portfolio.git"
              demoLink="https://tabarak-dev.netlify.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gsapProject}
              isBlog={false}
              title="AWWWARDS Site"
              description="This project demonstrates how to leverage GSAP's powerful animation capabilities to craft fluid transitions, captivating scroll effects, and dynamic UI interactions, combining it with React and Tailwind CSS for a truly immersive and visually stunning website."
              ghLink="https://github.com/TabarakCodeCraft/GSAP-Awwwards-Website"
              demoLink="https://energydrink-website-with-gsap.netlify.app/"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={carRental}
              isBlog={false}
              title="Car Rental"
              description="Welcome to Car Rental, a modern full-stack web app for renting and managing cars with ease. Browse and view available cars, Create and manage bookings easily, Admins can add, edit, or delete cars, Multi-language support (English & Arabic), Secure authentication via Clerk"
              ghLink="https://github.com/TabarakCodeCraft/Car-Rental"
              demoLink="https://car-rental-frontend-by-tabarak2025.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Car Lover"
              description="An online code and markdown editor built with React.js. The editor supports HTML, CSS, and JavaScript, allowing users to see an instant preview of their work. It also provides a markdown editor for README file creation with a toolbar and auto-save feature using Local Storage. The CSS and HTML structure ensures a clean UI with responsive design."
              ghLink="https://github.com/TabarakCodeCraft/Car-lover"
              demoLink="https://car-lover-bytota.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="e-Commerce Flowers"
              description="A fully responsive e-commerce platform for flower shopping, built using HTML and CSS for patients who need easy access to flower orders. It provides a simple and accessible design, ensuring a smooth user experience."
              ghLink="https://github.com/TabarakCodeCraft/E-Commerce-Flowers"
              demoLink="https://design-flowers-website.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={macbook}
              isBlog={false}
              title="Portfolio OS Macbook"
              description="This is a React-based web application that replicates the macOS desktop interface, designed to create unique and memorable portfolios. Instead of traditional static websites, users can showcase their projects through an interactive desktop environment featuring windows, dock, and familiar macOS elements"
              ghLink="https://github.com/TabarakCodeCraft/Portfolio-Mac-OS"
              demoLink="https://mac-os-by-tabarak.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={lastProj}
              isBlog={false}
              title="Rental Car"
              description="A car rental platform built using React.js, designed to assist patients in finding rental cars easily. The platform offers a simple interface with a smooth booking process and responsive layout for accessibility across devices."
              ghLink="https://github.com/TabarakCodeCraft/cars-website-in-react"
              demoLink="https://toto-cars-lover.netlify.app/"
            />
          </Col>


        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
